if (!customElements.get('countdown-banner')) {
  customElements.define(
    'countdown-banner',
    class CountdownBanner extends HTMLElement {
      connectedCallback() {
        this.timerEl = this.querySelector('.js-countdown-banner__timer');
        this.isEditor = this.hasAttribute('data-editor') || Boolean(window.Shopify && window.Shopify.designMode);

        // Daily timer: counts to the next reset hour in the SHOPPER's local time
        // (new Date() is local) and rolls into the next day instead of
        // expiring, like Norse's end_of_day promo timer. Never hides itself;
        // the entry's Start/End decide when the banner shows.
        const resetHour = this.getAttribute('data-daily-reset-hour');
        if (resetHour !== null && this.timerEl) {
          this.resetHour = Math.min(23, Math.max(0, parseInt(resetHour, 10) || 0));
          this.#updateDaily();
          this.intervalId = setInterval(() => this.#updateDaily(), 1000);
          return;
        }

        const dueDate = this.getAttribute('data-due-date');
        if (!dueDate || !this.timerEl) return;

        this.endTime = new Date(dueDate).getTime();
        if (Number.isNaN(this.endTime)) return;

        this.#update();
        this.intervalId = setInterval(() => this.#update(), 1000);
      }

      disconnectedCallback() {
        if (this.intervalId) clearInterval(this.intervalId);
      }

      #updateDaily() {
        const now = new Date();
        const next = new Date(now.getFullYear(), now.getMonth(), now.getDate(), this.resetHour, 0, 0, 0);
        if (next < now) next.setDate(next.getDate() + 1);
        this.#render(next - now);
      }

      #render(distance) {
        const h = Math.floor(distance / (1000 * 60 * 60));
        const m = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const s = Math.floor((distance % (1000 * 60)) / 1000);

        this.timerEl.textContent =
          String(h).padStart(2, '0') + ':' +
          String(m).padStart(2, '0') + ':' +
          String(s).padStart(2, '0');
      }

      #update() {
        const distance = this.endTime - Date.now();

        if (distance <= 0) {
          this.timerEl.textContent = '00:00:00';
          if (this.intervalId) clearInterval(this.intervalId);
          if (!this.isEditor) this.style.display = 'none';
          return;
        }

        this.#render(distance);
      }
    }
  );
}
